import type { DevCenterComponent } from '../dev-center-component.js';
import { composeValidations, pathValidation } from './common.js';

const PATH_INVALID_MESSAGE =
  'The page route must be a valid URL path ([a-z0-9-/]+) and must not start with a dot.';
const ROUTE_EXISTS_MESSAGE =
  'The page route must be unique, please choose a route that has not been used yet in your application.';

function pageRouteExistsValidation(
  existingPages: Array<DevCenterComponent<'DashboardPage'>>
) {
  return (route: string) =>
    existingPages.every((page) => page.route !== `/${route}`);
}

export function createDashboardRouteValidation(
  dashboardPages: Array<DevCenterComponent<'DashboardPage'>>
) {
  return composeValidations([
    [pageRouteExistsValidation(dashboardPages), ROUTE_EXISTS_MESSAGE],
    [pathValidation, PATH_INVALID_MESSAGE],
  ]);
}
